export const profile = [{
    name: "Deborah van der Weel",
    aboutme: "I’m Deborah van der Weel. Currently frontend developer ",
    job: "@Coolblue",
    prev: ". Previously ",
    job2: "@Connect Holland",
    school: ". Media Technology Alumni from ",
    university: "@Rotterdam University of Applied Sciences",
    jobUrl: "https://www.coolblue.nl",
    jobUrl2: "https://www.connectholland.nl",
    universityUrl: "https://www.rotterdamuas.com/about/organisation/schools/school-of-communication-media-and-information-technology/welcome/"
}]